import React from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { MBIconV2, MBIconV2Name } from '@shared/components/image';
import { MBTouchableOpacity } from '@shared/components/touchable';
import { grid } from '@shared/styles';

export interface IconButtonProps {
  color: string;
  name: MBIconV2Name;
  size?: number;
  onPress?: (node: React.Component) => unknown;
  testID?: string;
  style?: StyleProp<ViewStyle>;
  iconStyle?: StyleProp<ViewStyle>;
}

export function IconButtonV2({
  name,
  onPress,
  size = grid(4),
  color,
  testID,
  style,
  iconStyle,
}: IconButtonProps) {
  return (
    <MBTouchableOpacity disabled={!onPress} onPress={onPress} testID={testID} style={style}>
      <MBIconV2 name={name} color={color} size={size} style={iconStyle} />
    </MBTouchableOpacity>
  );
}
